export enum EDateRangeType {
  thisWeek = 'thisWeek',
  thisMonth = 'thisMonth',
  last7Days = 'last7Days',
  last30Days = 'last30Days',
  allTime = 'allTime',
  custom = 'custom',
}

/** The 3 selectable modes for the "Compare" section (compares the main range against another). */
export enum ECompareRangeType {
  none = 'none',
  previousPeriod = 'previousPeriod',
  custom = 'custom',
}

export interface ICompareRange {
  endDate: Date;
  startDate: Date;
}

export interface IAdjustRangeForCampaignResult {
  end: Date;
  isCustom: boolean;
  start: Date;
}

export interface IProfileDateFilterState {
  endDate: Date | null;
  selectedRange: EDateRangeType;
  startDate: Date | null;
}

export interface IDateRangeBounds {
  end: Date;
  start: Date;
}
